module.exports = __webpack_public_path__ + "img/profile_box_place_name.5953ef5f.svg";